module.exports = __webpack_public_path__ + "img/network-status-mobile.dd138541.jpg";